/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_124_TitleInputs */

const en_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bellflower`)
};

const ar_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زهرة الجرس`)
};

const de_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glockenblume`)
};

const es_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flor Campanilla`)
};

const fr_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanule`)
};

const it_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campanula`)
};

const ja_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベルフラワー`)
};

const ko_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`초롱꽃`)
};

const pt_br_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campânula`)
};

const ru_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Колокольчик`)
};

const th_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดอกระฆัง`)
};

const tr_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çan çiçeği`)
};

const zh_cn_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风铃草`)
};

const zh_tw_tree_type_124_title = /** @type {(inputs: Tree_Type_124_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`風鈴草`)
};

/**
* | output |
* | --- |
* | "Bellflower" |
*
* @param {Tree_Type_124_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_124_title = /** @type {((inputs?: Tree_Type_124_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_124_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_124_title(inputs)
	if (locale === "ar") return ar_tree_type_124_title(inputs)
	if (locale === "de") return de_tree_type_124_title(inputs)
	if (locale === "es") return es_tree_type_124_title(inputs)
	if (locale === "fr") return fr_tree_type_124_title(inputs)
	if (locale === "it") return it_tree_type_124_title(inputs)
	if (locale === "ja") return ja_tree_type_124_title(inputs)
	if (locale === "ko") return ko_tree_type_124_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_124_title(inputs)
	if (locale === "ru") return ru_tree_type_124_title(inputs)
	if (locale === "th") return th_tree_type_124_title(inputs)
	if (locale === "tr") return tr_tree_type_124_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_124_title(inputs)
	return zh_tw_tree_type_124_title(inputs)
});